export const toNumber = (value) => {
  if (value === "" || value === null || value === undefined) return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const formatNumber = (value) => {
  if (value === "" || value === null || value === undefined) return "-";
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return value;
  return parsed.toString();
};

export const formatNumberWithCommas = (value, digits = null) => {
  if (value === "" || value === null || value === undefined) return "-";
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return value;
  const options =
    typeof digits === "number"
      ? { minimumFractionDigits: digits, maximumFractionDigits: digits }
      : undefined;
  return new Intl.NumberFormat(undefined, options).format(parsed);
};

export const formatPercent = (value, digits = 2) => {
  if (value === "" || value === null || value === undefined) return "-";
  const parsed = Number(value);
  if (Number.isNaN(parsed)) return value;
  const isWhole = Number.isInteger(parsed);
  return `${parsed.toFixed(isWhole ? 0 : digits)}%`;
};
